export const CancelWorkFlowCommandName = 'CancelWorkFlowCommandComponent';
